import { IconLoading1 } from 'components/Icons'
import React, { memo } from 'react'
import styled from 'styled-components'

interface LoadingProps {
  isLoading: boolean
}

const Loading: React.FC<LoadingProps> = (props) => {
  const { isLoading } = props

  if (!isLoading) {
    return <></>
  }

  return (
    <StyledLoading>
      <IconLoading1 />
    </StyledLoading>
  )
}

const StyledLoading = styled.div`
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.loading};
  min-height: 100px;
  z-index: 999;

  ${(props) => `
   background-image: linear-gradient(to bottom, ${props.theme.color.primary}00, ${props.theme.color.primary})`}
`
export default memo(Loading)
